import React from 'react';
import Section from '@latitude/section';
import { Typography } from '../Typography';
import Button from '@/components/lab-components/Button';
import { BUTTON_THEME } from '@/utils/constants';
import './_card_feature.scss';

const CardFeature = ({
  title,
  image,
  reward,
  cardName,
  description,
  ctaText,
  ctaLink,
  disclaimer,
  altText
}) => {
  return (
    <div className="card-feature">
      <Section className="card-feature__section">
        {title && (
          <Typography.H4 className="card-feature__section-title">
            {title}
          </Typography.H4>
        )}

        <div className="card-feature__wrapper">
          {/* CardArt Image */}
          {image && (
            <div className="card-feature__image-wrapper">
              <img src={image} alt={altText} className="card-feature__image" />
            </div>
          )}

          {/* CardFeature Content */}
          <div className="card-feature__content">
            {reward && <p className="card-feature__reward">{reward}</p>}
            {cardName && (
              <Typography.H5 className="card-feature__title">
                {cardName}
              </Typography.H5>
            )}
            {description && (
              <Typography.BODY className="card-feature__description">
                {description}
              </Typography.BODY>
            )}
            {ctaText && ctaLink && (
              <Button
                theme={BUTTON_THEME.LINK}
                href={ctaLink}
                trackId="learn-more"
                trackEventData={{
                  category: 'text-link',
                  action: 'internal-link',
                  location: title.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, ''),
                  label: ctaText
                }}
                trackProductId={['CCAUGEM']}
                text={ctaText}
                css={`
                  &:hover {
                    background: none !important;
                  }
                `}
              />
            )}
          </div>
        </div>
        {disclaimer && (
          <Typography.LEGAL className="card-feature__disclaimer">
            {disclaimer}
          </Typography.LEGAL>
        )}
      </Section>
    </div>
  );
};

export default CardFeature;
